<template>
  <footer class="vi-footer">
    <div class="vi-footer-container">
      <!-- 左侧Logo+简介 -->
      <div class="vi-footer-col vi-col-left">
        <div class="vi-footer-logo">
          <!-- 替换为你的logo图片 -->
          <img src="@/assets/img/logo1.svg" alt="WEBFBA Logo" class="vi-logo-img">
        </div>
        <p class="vi-footer-desc">
          Webfba – We are the All-In-One Dropshipping agent who helps you source and ship anything you need, such as general cargo, liquid, sensitive cargo, what more, we also offer POD service, One-piece also can be customized.
        </p>
      </div>

      <!-- 中间 What we offer 菜单 -->
      <div class="vi-footer-col vi-col-middle">
        <h4 class="vi-footer-subtitle">What we offer</h4>
        <ul class="vi-footer-link-list">
          <li v-for="item in offerList" :key="item">
            <a href="#" class="vi-footer-link">{{ item }}</a>
          </li>
        </ul>
      </div>

      <!-- 右侧 Our Company 菜单 -->
      <div class="vi-footer-col vi-col-right">
        <h4 class="vi-footer-subtitle">Our Company</h4>
        <ul class="vi-footer-link-list">
          <li v-for="item in companyList" :key="item">
            <a href="#" class="vi-footer-link">{{ item }}</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
  data() {
    return {
      offerList: [
        "Services",
        "POD",
        "Product",
        "Price",
        "Delivery",
        "Time",
        "Processing"
      ],
      companyList: [
        "About Us",
        "Why Us?",
        "Contact Us"
      ]
    }
  }
}
</script>

<style scoped lang="stylus">
$dark-bg = #1a262e
$orange = #ff8800
$white = #ffffff
$link-gray = #f0f0f0

.vi-footer
  background $dark-bg
  padding 70px 20px
  width 100%

.vi-footer-container
  max-width 1400px
  margin 0 auto
  display flex
  gap 50px
  flex-wrap wrap

.vi-footer-col
  flex 1
  min-width 240px

// 左侧Logo区域
.vi-footer-logo
  display flex
  align-items center
  gap 10px
  margin-bottom 24px
  .vi-logo-img
    height 70px
    object-fit contain
  .vi-logo-text
    font-size 42px
    font-weight bold
    color $orange

.vi-footer-desc
  color $link-gray
  font-size 14px
  line-height 1.7
  margin 0

// 栏目标题
.vi-footer-subtitle
  font-size 20px
  color $orange
  margin 0 0 20px
  font-weight 600

// 链接列表
.vi-footer-link-list
  list-style none
  padding 0
  margin 0
  li
    margin-bottom 12px
  .vi-footer-link
    color $link-gray
    font-size 14px
    text-decoration none
    transition color 0.2s
    &:hover
      opacity 0.8
      cursor pointer

// 平板适配
@media (max-width: 992px)
  .vi-footer-container
    gap 40px
  .vi-footer-subtitle
    font-size 24px
  .vi-footer-link
    font-size 17px
  .vi-footer-desc
    font-size 16px

// 手机适配
@media (max-width: 576px)
  .vi-footer-container
    flex-direction column
    gap 30px
  .vi-logo-text
    font-size 32px
  .vi-footer-subtitle
    font-size 22px
</style>